// Vendors
import { useEffect, useMemo, useRef, useState } from 'react';
import { sessionUtils } from '@openbank/cf-ui-architecture-core';
// Config
import { executeAfterConfig } from './configurations/useWebSocket.configuration';
// Hooks
import { useExecuteAfter } from '../useExecuteAfter';
// Handlers
import { WebsocketHandlers } from './handlers/useWebSocket.handlers';
// Utils
import { getDefaultUrl, webSocketHasLegitInitMessage } from './utils/useWebSockets.utils';
const useWebSocketHook = ({ onReceiveData, onError, limitConfiguration, initMessage, refreshToken = sessionUtils.refreshToken, // TODO - se eliminará por un refreshToken global
retryMount = false, url = getDefaultUrl, }) => {
    const webSocketRef = useRef(null);
    const [webSocketConnected, setWebSocketConnected] = useState(false);
    const config = useMemo(() => executeAfterConfig({ ...limitConfiguration, webSocketRef }), []);
    const { startTimer, stopTimer } = useExecuteAfter(config);
    const { initializeSocketHandler, webSocketSendMessage, webSocketDisconnect } = useMemo(() => WebsocketHandlers({
        initMessage,
        onError,
        onReceiveData,
        refreshToken,
        setWebSocketConnected,
        startTimer,
        stopTimer,
        url,
        webSocketRef,
    }), [retryMount]);
    useEffect(() => {
        if (webSocketHasLegitInitMessage(initMessage)) {
            window.console.debug('WebSocket is trying to connect...');
            initializeSocketHandler();
            return () => {
                window.console.debug('WebSocket is disconnecting...');
                webSocketDisconnect();
            };
        }
        else {
            // We return all is ok even we did not try to connect the WebSocket (Fake positive)
            setWebSocketConnected(true); //
            window.console.warn('WebSocket initialization skipped due to missing endpoint in initMessage.');
        }
    }, []);
    useEffect(() => {
        window.console.debug('Websocket has been ordered to retry connection.');
        if (retryMount &&
            !webSocketConnected &&
            webSocketHasLegitInitMessage(initMessage) &&
            !webSocketRef.current) {
            window.console.debug('WebSocket is not connected, retrying connection...');
            initializeSocketHandler();
        }
    }, [retryMount]);
    return {
        webSocketConnected,
        webSocketDisconnect,
        webSocketSendMessage,
    };
};
export { useWebSocketHook };
//# sourceMappingURL=useWebSocket.js.map